import React from "react";
import Navbar from "./Navbar";
import Skillicons from "./Skills";
import { Animated } from "react-animated-css";

const AboutPage = () => {
  return (
    <React.Fragment>
      <div className="container">
        <Navbar />
        <hr></hr>
        <Animated animationIn="fadeInDown" isVisible={true}>
          <Skillicons />
        </Animated>
        <hr></hr>
        <Animated animationIn="fadeInDown" isVisible={true}>
          <h4 className="ml-4 mb-4 mt-5">Internships</h4>
        </Animated>
        <Animated animationIn="fadeInDown" isVisible={true}>
          <h5 className="ml-4 mb-4">Solera Life Science Private Limited</h5>
          <p className="ml-4 mb-4">
            I am currently working as website developer and designer building
            couple of products. One of them Is basically a E-commerce app for
            Pharma products and other product is based on building chat bot
            interface (familiar example DialogueFlow)
          </p>
        </Animated>
        <Animated animationIn="fadeInDown" isVisible={true}>
          <h5 className="ml-4 mb-4">National University of Singapore </h5>
          <p className="ml-4 mb-4">
            I was involved in academic internship in Singapore. I built two
            projects, one was based IOT based Disaster management system and the
            second project was based on visualising data in admin Dashboard.
          </p>
        </Animated>
      </div>
    </React.Fragment>
  );
};

export default AboutPage;
